import axios from '@/libs/axios';
import { MutationConfig, queryClient } from '@/libs/react-query';
import { useMutation } from '@tanstack/react-query';

//
export interface BalanceUpdateRequest {
  user_id: number;
  over: string;
  desc: string;
  lock: string;
  // update_type: number;
  coin: string;
}

export interface BalanceUpdateResponse extends Response {
  data: null;
}

//
export const balanceUpdate = (data: BalanceUpdateRequest): Promise<BalanceUpdateResponse> => {
  return axios.post('/account/changeAssets', data);
};

type UseBalanceUpdateOptions = {
  config?: MutationConfig<typeof balanceUpdate>;
};

//
export const useBalanceUpdate = ({ config }: UseBalanceUpdateOptions) => {
  return useMutation({
    onSettled: () => {
      queryClient.invalidateQueries(['user-assets']);
    },
    mutationFn: balanceUpdate,
    ...config,
  });
};
